import Pubblicazioni from "./Pubblicazioni";
export default Pubblicazioni;